/* A small, on-demand lathed jar renderer. Real print artwork wraps around the
   curved body; the approved packshot remains the accessible/default image. */
(() => {
  'use strict';
  const vertex = `attribute vec3 position; attribute vec3 normal; attribute vec2 uv; attribute float material;
    uniform float angle; varying vec3 N; varying vec3 P; varying vec2 UV; varying float M;
    void main(){float c=cos(angle),s=sin(angle);mat3 spin=mat3(c,0.,-s,0.,1.,0.,s,0.,c);
      P=spin*position;N=spin*normal;UV=uv;M=material;
      float tilt=.075;float y=cos(tilt)*P.y-sin(tilt)*P.z;
      float z=sin(tilt)*P.y+cos(tilt)*P.z;
      gl_Position=vec4((P.x+.025)/1.16,y/1.45,-z/4.,1.);}`;
  const fragment = `precision highp float; varying vec3 N; varying vec3 P; varying vec2 UV; varying float M;
    uniform sampler2D label; uniform float front;
    void main(){vec3 n=normalize(N);vec3 v=normalize(vec3(0.,.075,1.));
      vec3 light=normalize(vec3(-.65,.65,1.));float diffuse=max(dot(n,light),0.);
      vec3 h=normalize(light+v);float spec=pow(max(dot(n,h),0.),34.);
      float strip=exp(-pow((n.x+.58)/.18,2.))*pow(max(n.z,0.),.5);
      float rim=exp(-pow((n.x-.75)/.13,2.))*pow(max(n.z,0.),.5);
      vec3 color;
      if(M>.5 && M<1.5){color=texture2D(label,vec2(fract(UV.x+front),clamp(UV.y,0.,1.))).rgb;
        color*=.58+.42*diffuse;color+=vec3(.065*strip+.035*spec);}
      else {color=vec3(.035,.038,.041)*(.65+.55*diffuse)+vec3(.25*spec+.28*strip+.12*rim);
        if(M>1.5){float rib=.96+.04*cos(UV.x*6.283185*36.);color*=rib;}}
      gl_FragColor=vec4(color,1.);}`;
  function geometry(){
    // [height, radius]. Separate rings keep the cap lip and shoulder crisp.
    const parts=[
      {m:0,p:[[-1.005,0],[-1.005,.92],[-1.0,.97],[-.982,.99],[-.95,1],[-.82,1]]},
      {m:1,p:[[-.82,1.001],[.50,1.001]]},
      {m:0,p:[[.50,1],[.55,.994],[.58,.965],[.60,.96],[.61,1.005],[.635,1.005],[.65,.97]]},
      {m:2,p:[[.65,.98],[.66,1.002],[.68,1.005],[.965,1.005],[.99,.985],[1.003,.945],[1.01,.87],[1.01,0]]}
    ];
    const data=[];const segments=128;
    for(const {p,m} of parts)for(let j=0;j<p.length-1;j++){
      const [y0,r0]=p[j],[y1,r1]=p[j+1];const dy=y1-y0,dr=r1-r0,l=Math.hypot(dy,dr)||1;
      const emit=(i,k)=>{const a=i/segments*Math.PI*2,[y,r]=p[k];
        data.push(r*Math.sin(a),y,r*Math.cos(a),dy/l*Math.sin(a),-dr/l,dy/l*Math.cos(a),i/segments,(y+.82)/1.32,m)};
      for(let i=0;i<segments;i++){emit(i,j);emit(i+1,j);emit(i,j+1);emit(i+1,j);emit(i+1,j+1);emit(i,j+1)}
    }return new Float32Array(data);
  }
  function shader(gl,type,source){const s=gl.createShader(type);gl.shaderSource(s,source);gl.compileShader(s);if(!gl.getShaderParameter(s,gl.COMPILE_STATUS))throw Error('Jar shader unavailable');return s}
  window.gpCreateTurntable=async function(imageLink){
    const card=imageLink.closest('.gp-product-card'),url=card?.dataset.turntableLabel;
    const pack=imageLink.querySelector('.gp-packshot'),photo=pack?.querySelector('img');
    if(!url||!photo)return null;
    const textureImage=new Image();textureImage.crossOrigin='anonymous';textureImage.src=url;
    try{await textureImage.decode();await photo.decode()}catch{return null}
    const canvas=document.createElement('canvas');canvas.className='gp-turntable';canvas.setAttribute('aria-hidden','true');
    canvas.width=520;canvas.height=650;
    const gl=canvas.getContext('webgl',{alpha:true,antialias:true,premultipliedAlpha:true});if(!gl)return null;
    let disposed=false,raf=0,finish=null,playing=false;
    try{
      const vs=shader(gl,gl.VERTEX_SHADER,vertex),fs=shader(gl,gl.FRAGMENT_SHADER,fragment);
      const program=gl.createProgram();gl.attachShader(program,vs);gl.attachShader(program,fs);gl.linkProgram(program);
      if(!gl.getProgramParameter(program,gl.LINK_STATUS))throw Error('Jar program unavailable');gl.useProgram(program);
      const vertices=geometry(),buffer=gl.createBuffer();gl.bindBuffer(gl.ARRAY_BUFFER,buffer);gl.bufferData(gl.ARRAY_BUFFER,vertices,gl.STATIC_DRAW);
      for(const [name,size,offset] of [['position',3,0],['normal',3,3],['uv',2,6],['material',1,8]]){const loc=gl.getAttribLocation(program,name);gl.enableVertexAttribArray(loc);gl.vertexAttribPointer(loc,size,gl.FLOAT,false,36,offset*4)}
      const texture=gl.createTexture();gl.bindTexture(gl.TEXTURE_2D,texture);gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);
      gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,textureImage);
      gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE);
      gl.uniform1i(gl.getUniformLocation(program,'label'),0);gl.uniform1f(gl.getUniformLocation(program,'front'),Number(card.dataset.turntableFront||.35));
      const angle=gl.getUniformLocation(program,'angle');gl.enable(gl.DEPTH_TEST);gl.viewport(0,0,520,650);gl.clearColor(0,0,0,0);
      pack.appendChild(canvas);
      function draw(progress,blend){
        if(disposed)return;gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER_BIT);gl.uniform1f(angle,progress*Math.PI*2);gl.drawArrays(gl.TRIANGLES,0,vertices.length/9);
        canvas.style.opacity=String(blend);photo.style.opacity=String(1-blend);canvas.dataset.turn=progress.toFixed(4);
      }
      function stop(){cancelAnimationFrame(raf);playing=false;photo.style.removeProperty('opacity');canvas.style.opacity='0';finish?.();finish=null}
      function dispose(){if(disposed)return;stop();disposed=true;gl.deleteTexture(texture);gl.deleteBuffer(buffer);gl.deleteProgram(program);gl.deleteShader(vs);gl.deleteShader(fs);gl.getExtension('WEBGL_lose_context')?.loseContext();canvas.remove()}
      canvas.addEventListener('webglcontextlost',event=>{event.preventDefault();stop()});
      function play(delay=0){if(disposed)return Promise.resolve();stop();playing=true;return new Promise(resolve=>{
        finish=resolve;const start=performance.now()+delay,duration=2200;
        function tick(now){if(!playing||disposed)return;if(now<start){raf=requestAnimationFrame(tick);return}
          const t=Math.min(1,(now-start)/duration);
          // Smooth acceleration and deceleration, one complete upright revolution.
          const eased=t*t*(3-2*t);const blend=Math.min(1,t/.09,(1-t)/.09);
          draw(eased,Math.max(0,blend));if(t<1)raf=requestAnimationFrame(tick);else stop();
        }raf=requestAnimationFrame(tick);
      })}
      return {play,stop,dispose,draw};
    }catch{gl.getExtension('WEBGL_lose_context')?.loseContext();canvas.remove();return null}
  };
})();
